export default function GalleryHero() {
  return (
    <section className="relative w-full h-[60vh] min-h-[480px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="/assets/img/festival-vendor-village-29.webp"
          alt="Pop Pro Tents Gallery Hero"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
      </div>
      <div className="relative z-10 text-center px-4 w-full">
        <h1 className="text-6xl md:text-7xl font-extrabold text-white leading-tight mb-5">
          Our Work in Action
        </h1>
        <p className="text-xl md:text-2xl text-white/90 max-w-2xl mx-auto">
          From intimate weddings to large-scale festivals, we&apos;ve got you covered
        </p>
      </div>
    </section>
  );
}
